class CartInterceptor {
    static instance = null;
    static event = 'oncartupdate';
    static event_add = 'oncartadd';
    static fetch = window.fetch.bind(window);
    static urls = [
        '/cart.js',
        '/cart/add',
        '/cart/add.js',
        '/cart/change.js',
        '/cart/clear.js',
        '/cart/update.js',
        '/cart.json'
    ];

    static getInstance() {
        if (!CartInterceptor.instance) {
            CartInterceptor.instance = new CartInterceptor();
        }

        return CartInterceptor.instance;
    }

    constructor() {
        window.fetch = this.fetch;
        window.XMLHttpRequest = new Proxy(window.XMLHttpRequest, {
            construct: (target, args) => {
                const xhr = new target(...args);
                const open = xhr.open.bind(xhr);
                const send = xhr.send.bind(xhr);

                xhr.open = (...args) => {
                    if (CartInterceptor.urls.some((u) => args[1].includes(u))) {
                        xhr.addEventListener('load', () => {
                            if (xhr.status === 200) {
                                CartInterceptor.updateCart();
                            }
                        });
                    }

                    return open(...args);
                };

                xhr.send = (...args) => {
                    if (CartInterceptor.urls.some((u) => xhr.responseURL.includes(u))) {
                        xhr.addEventListener('load', () => {
                            if (xhr.status === 200) {
                                CartInterceptor.updateCart();
                            }
                        });
                    }

                    return send(...args);
                };

                return xhr;
            }
        });
    }

    static deepEqual(source, object) {
        return JSON.stringify(source) === JSON.stringify(object);
    }

    static getAddedItem(cart, oldCart) {
        if (!cart || !oldCart || (cart.item_count <= oldCart.item_count)) {
            return null;
        }

        if (cart.items.length === oldCart.items.length) {
            for (let i = 0; i < cart.items.length; i++) {
                if (cart.items[i].quantity > oldCart.items[i].quantity) {
                    return cart.items[i];
                }
            }
        }

        return cart.items[0];
    }

    static async updateCart() {
        try {
            const response = await CartInterceptor.fetch('/cart.js');
            const cart = await response.json();

            if (!CartInterceptor.deepEqual(window.shopifyCart, cart)) {
                const addedItem = CartInterceptor.getAddedItem(cart, window.shopifyCart);
                window.shopifyCart = cart;

                const event = new Event(CartInterceptor.event);
                window.dispatchEvent(Object.defineProperty(event, 'cart', { value: cart }));

                if (addedItem) {
                    const event = new Event(CartInterceptor.event_add);
                    window.dispatchEvent(Object.defineProperty(event, 'cart', { value: { ...cart, addedItem } }));
                }
            };
        } catch (error) {
            console.error(error);
        }
    }

    async fetch(url, options) {
        if (CartInterceptor.urls.some((u) => url.includes(u))) {

            const response = await CartInterceptor.fetch(url, options);

            if (response.ok) {
                CartInterceptor.updateCart();
            }

            return response;
        }

        return CartInterceptor.fetch(url, options);
    }
}

CartInterceptor.getInstance();